<template>
  <div class="expand-item-container">
    <div class="expand-item">
      批次：{{row.saleOrderDetailGoodsBatch}}
    </div>
    <div class="expand-item">
      供应商：{{row.saleOrderDetailSupplierName}}
    </div>
    <div class="expand-item">
      生产厂家：{{row.saleOrderDetailManufacturer}}
    </div>
    <div class="expand-item">
      生产日期：{{manufactureDate}}
    </div>
    <div class="expand-item">
      销售日期：{{createTime}}
    </div>
  </div>

</template>
<script>
import utils from '../../libs/utils';

export default {
  name: 'EditReturnExpand',
  props: {
    row: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    createTime() {
      return utils.formatTime(this.row.saleOrderDetailCreateTime, 'YYYY/MM/DD');
    },
    manufactureDate() {
      return utils.formatTime(this.row.saleOrderDetailManufactureDate, 'YYYY/MM/DD');
    },
  },
};
</script>
